import { render } from "./Login.vue?vue&type=template&id=099a7143"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script